var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.68325H18V14.5C18 15.1945 17.7569 15.7847 17.2708 16.2708C16.7848 16.7569 16.1945 17 15.5 17H2.5C1.8055 17 1.21525 16.7569 0.72925 16.2708C0.243083 15.7847 0 15.1945 0 14.5V4.68325ZM1.66675 6.35V14.5C1.66675 14.7362 1.74658 14.9341 1.90625 15.0937C2.06592 15.2534 2.26383 15.3333 2.5 15.3333H15.5C15.7362 15.3333 15.9341 15.2534 16.0938 15.0937C16.2534 14.9341 16.3333 14.7362 16.3333 14.5V6.35H1.66675ZM0 3.68325V2H6.16675V0.83325C6.16675 0.59725 6.24658 0.399334 6.40625 0.2395C6.56592 0.0798337 6.76383 0 7 0H11C11.2362 0 11.4341 0.0798337 11.5938 0.2395C11.7534 0.399334 11.8333 0.59725 11.8333 0.83325V2H18V3.68325H0Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenManagementIcon);
export default __webpack_public_path__ + "static/media/kitchen_management_icon.abe7715f79977285679fb76b6280d8fe.svg";
export { ForwardRef as ReactComponent };